import {Card, Col, message, Row, Statistic, Tag, Tooltip} from "antd";
import  {useCallback, useEffect, useState} from "react";
import jobApiService from "../../../service/jobApiService";
import twilioApiService from "../../../service/twilioApiService";
import LocalRoomComp from "./LocalRoomComp";
import {ParticipantStatus} from "../../../enums/ParticipantStatus";
import {VideoStatus} from "../../../enums/VideoStatus";

import './style.scss'
import {WifiOutlined} from "@ant-design/icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBriefcase, faCircle, faIdCard, faUserLarge, faUserLargeSlash} from "@fortawesome/free-solid-svg-icons";
import {FileProperty} from "../../common/documentviewer/FileProperty";
import {CustomerDto} from "../../../dto/CustomerDto";
import LeftSideDetailsCollapse from "../../admin/documentanddetailsverification/leftSideCollapse";
import {faUser} from '@fortawesome/free-solid-svg-icons/faUser';
import {faPhone} from '@fortawesome/free-solid-svg-icons/faPhone';

interface JobDetail {
    assignedBy: string,
    informerEmail: string,
    informerMobileNo: string,
    informerName: string,
    jobDescription: string,
    jobNumber: number,
    identityDocumentTypeCode: string,
    jobId: number,
    idNo: string,
    callDetailsDtoList: []
}

const MainLocalVideoView = ({
                                callId,
                                addDocumentWindow,
                                removeDocumentWindow,
                                customerData,
                                workId,
                                basketStatus,
                                cin,
                            }: {
    callId: string,
    addDocumentWindow(fileProperty: FileProperty, contentType: string): void,
    removeDocumentWindow(documentTypeId: any): void,
    customerData: CustomerDto | undefined,
    workId: number,
    basketStatus:string,
    cin:string
}) => {

    const [jobDetail, setJobDetail] = useState<JobDetail>({
        assignedBy: "",
        jobId: 0,
        callDetailsDtoList: [],
        informerEmail: "",
        informerMobileNo: "",
        informerName: "",
        jobDescription: "",
        jobNumber: 0,
        identityDocumentTypeCode: "",
        idNo: ""
    });
    const [username, setUsername] = useState('');
    const [roomName, setRoomName] = useState('');
    const [token, setToken] = useState('');
    const [callLink, setCallLink] = useState('');
    const [scheduledDateTime, setScheduledDateTime] = useState('');
    const [videoStatus, setVideoStatus] = useState<VideoStatus>(VideoStatus.OFFLINE);
    const [participantConnectingStatus, setParticipantConnectingStatus] = useState<ParticipantStatus>(ParticipantStatus.PENDING);



    // const routeParams: { callId: "0" } = useParams();

    const handleLogout = useCallback((event: any) => {
        setToken('');
    }, []);

    const onVideoStatusProgress = (status: VideoStatus) => {
        setVideoStatus(status);
    }

    const onParticipantConnectingStatusProgress = (status: ParticipantStatus) => {
        setParticipantConnectingStatus(status);
    }

    useEffect(() => {
        setVideoStatus(VideoStatus.CONNECTING);
        if (username === '') {
            jobApiService.getJobDetailByCallId(callId).then(res => {
                setJobDetail(res.data.results);
                let callDetail = res.data.results.callDetailsDtoList[0];
                setScheduledDateTime(callDetail.fromScheduledDateTime)
                setUsername(callDetail.localUserAccessToken);
                setRoomName(callDetail.roomName);
                setCallLink(callDetail.link);
                twilioApiService.getTwilioToken(callDetail.localUserAccessToken, callDetail.roomName).then(res1 => {
                    setToken(res1.data.results.token);
                }).catch(reason => {
                    console.log(reason.response.data.errors[0].errorMessage);
                    message.error(reason.response.data.errors[0].errorMessage);
                })
            }).catch(reason => {
                console.log(reason.response.data.errors[0].errorMessage);
                message.error(reason.response.data.errors[0].errorMessage);
            })
        }

    }, [callId]);

    let render;
    if (token) {
        render = (
            <LocalRoomComp roomName={roomName} token={token} handleLogout={handleLogout}
                           username={username}
                           jobNumber={jobDetail.jobNumber}
                           identityDocumentTypeCode={jobDetail.identityDocumentTypeCode}
                           setVideoStatusProgress={onVideoStatusProgress}
                           setParticipantConnectingStatus={onParticipantConnectingStatusProgress}
                           participantConnectingStatus={participantConnectingStatus}
                           addDocumentWindow={addDocumentWindow}
                           callLink={callLink}
                           workId={workId}
                           scheduledDateTime={scheduledDateTime}
                           basketStatus={basketStatus}
                           cin={cin}

            />
        );
    } else {
        render = <div>Please wait...</div>
    }

    return <>
        <Row gutter={[16, 0]} className='video-call-component-row'>
            <Col xxl={{span: 24, offset: 0}} xl={{span: 24, offset: 0}} lg={{span: 24, offset: 0}}
                 md={{span: 24, offset: 0}} sm={{span: 24}} className='video-call-main-col' style={{paddingRight:0, paddingLeft:0}}>

                <Card size='small' className='main-video-card card-body-padding' style={{marginTop: 0}}>
                    <Row>
                        <Col span={24}>
                            <div className="top-info-row">
                                <div className='meet-info-card-admin'>
                                    <div className="meet-info-icon">
                                        <FontAwesomeIcon icon={faBriefcase}/>
                                    </div>
                                    <Statistic className='admin-meet-info' title="Job Number"
                                               formatter={(value: number) => String(value).replace(',', '')}
                                               value={jobDetail.jobNumber}/>
                                </div>
                                <div className='meet-info-card-admin'>
                                    <div className="meet-info-icon">
                                        <FontAwesomeIcon icon={faIdCard}/>
                                    </div>
                                    <Statistic className='admin-meet-info'  title="ID Number" value={jobDetail.idNo}
                                               formatter={(value: string) => value.replace(',', '')}
                                    />
                                </div>
                                <div className='meet-info-card-admin'>
                                    <div className="meet-info-icon">
                                        <FontAwesomeIcon icon={faUser}/>
                                    </div>
                                    <Statistic className='admin-meet-info' title="Customer Name" value={jobDetail.informerName}/>
                                </div>
                                <div className='meet-info-card-admin'>
                                    <div className="meet-info-icon">
                                        <FontAwesomeIcon icon={faPhone}/>
                                    </div>
                                    <Statistic  className='admin-meet-info' title="Mobile Number"
                                               formatter={(value: string) => value.replace(',', '')}
                                               value={jobDetail.informerMobileNo}/>
                                </div>



                                {/*<Statistic title="Reported Date" value={'2023-07-10'}/>*/}
                                <div>
                                    <div>
                                        {
                                            videoStatus == VideoStatus.OFFLINE
                                            || videoStatus === VideoStatus.CONNECTING
                                            || videoStatus === VideoStatus.ROOM_DISCONNECTED
                                                ?
                                                <div color="red"><FontAwesomeIcon color="red"
                                                                                  icon={faCircle}/> {videoStatus == VideoStatus.OFFLINE ? "Offline" : videoStatus}</div>
                                                : <div color="red"><FontAwesomeIcon color="green"
                                                                                    icon={faCircle}/> {videoStatus}
                                                </div>
                                        }

                                    </div>
                                    <div>
                                        <WifiOutlined style={{color: "green", marginRight: 5}}/>
                                        4G
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        {
                                            participantConnectingStatus == ParticipantStatus.PARTICIPANT_DISCONNECTED
                                            || participantConnectingStatus === ParticipantStatus.PENDING
                                            || participantConnectingStatus === ParticipantStatus.PARTICIPANT_RECONNECTING
                                            || participantConnectingStatus === ParticipantStatus.DISCONNECTED
                                            || participantConnectingStatus === ParticipantStatus.PARTICIPANT_RECONNECTED
                                                ? <Tooltip placement="bottom" title={participantConnectingStatus}>
                                                    <Tag className='user-connect-tag' color="red"><FontAwesomeIcon icon={faUserLargeSlash}/></Tag>
                                                </Tooltip>
                                                : <Tooltip placement="bottom" title={participantConnectingStatus}>
                                                    <Tag className='user-connect-tag' color="green"><FontAwesomeIcon icon={faUserLarge}/></Tag>
                                                </Tooltip>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>

        <Row>
            <Col lg={24}>
                <div className="video-render">
                    {render}
                </div>
            </Col>
        </Row>
        {/*<Row>*/}
        {/*    <Col lg={24}>*/}
        {/*        <div className={'float_button_Set'}>*/}
        {/*           */}
        {/*        </div>*/}
        {/*    </Col>*/}
        {/*</Row>*/}


        {/*<Row gutter={[16, 0]} className='video-call-component-row margin_top_10 '>*/}
        {/*    <Col xxl={{span: 24, offset: 0}} xl={{span: 24, offset: 0}} lg={{span: 24, offset: 0}}*/}
        {/*         md={{span: 24, offset: 0}} sm={{span: 24}} className='video-call-main-col text_align_end'>*/}
        {/*        <Space>*/}
                    {/*<Button onClick={goBack} size={'large'} round>Back</Button>*/}

                    {/*<Button size={'large'} onClick={() => verifyOrReject(CUSTOMER_VERIFICATION_STATUS.DECLINED)}*/}
                    {/*        round type="primary" danger>Decline</Button>*/}

                    {/*<Button size={'large'} onClick={() => verifyOrReject(CUSTOMER_VERIFICATION_STATUS.REJECTED)}*/}
                    {/*        round type="primary" danger>Reject</Button>*/}

                    {/*<Button size={'large'} disabled={isApplicableForVideoVerification}*/}
                    {/*        onClick={() => verifyOrReject(CUSTOMER_VERIFICATION_STATUS.VERIFIED)}*/}
                    {/*        round*/}
                    {/*        style={{background: '#ff7400', color: 'white'}}>Verify</Button>*/}
        {/*        </Space>*/}


        {/*    </Col>*/}
        {/*</Row>*/}


        <Row className='margin_top_10'>
            <Card title="Details Entered by the Customer" style={{width: '100%'}}>
                {customerData && <LeftSideDetailsCollapse dataDto={customerData}/>}
            </Card>
        </Row>

    </>
};

export default MainLocalVideoView;
